import React from "react";
import ProjectCard from "../../shared/projectCard/ProjectCard";
import Button from '../../shared/button/Button'
import './Project.css'

const Project = () => {
    const featuredProjects = [
        {
            title: "File Manager",
            description: "File-manager that stores files using amazon s3 SDK in a postgresQL database using Primsa ORM.",
            github: "https://github.com/Chiadikaobixo/file-manager-api",
            live: "https://github.com/Chiadikaobixo/file-manager-api",
            stack: "",
            isPackage: true,
            isPrivate: true
        },
        {
            title: "Fintech Wallet",
            description: "A Wallet that performs basic transactions in a MySQL database using Sequelize ORM with PAYSTACK integration.",
            github: "https://github.com/Chiadikaobixo/fintech-wallet",
            live: "https://github.com/Chiadikaobixo/fintech-wallet",
            stack: "",
            isPackage: true,
            isPrivate: true
        },
        {
            title: "NFT-Marketplace",
            description: "It performs the basic function of a marketplace and it requires a one time listing fee for minted and bought nft's.",
            github: "https://github.com/Chiadikaobixo/NFT-MarketPlace",
            live: "https://github.com/Chiadikaobixo/NFT-MarketPlace",
            stack: "",
            isPackage: true,
            isPrivate: true
        },
        {
            title: "Solidity",
            description: "A collection of all the solidity codes I have written, tested and deployed to a testnet network.",
            github: "https://github.com/Chiadikaobixo/my-solidity",
            live: "https://github.com/Chiadikaobixo/my-solidity",
            stack: "",
            isPackage: true,
            isPrivate: true
        },
    ]
    const openSource = [
        {
            title: "Ballerine-io",
            description: "Open-Source Rules & Workflow Engine for User Identity and Risk Decisioning",
            github: "https://github.com/ballerine-io/ballerine",
            live: "https://github.com/ballerine-io/ballerine",
            stack: "",
            isPackage: true,
            isPrivate: true
        },
        {
            title: "TheAlgorithms/Solidity",
            description: "Solidity data structures and algorithm",
            github: "https://github.com/TheAlgorithms/Solidity",
            live: "https://github.com/TheAlgorithms/Solidity",
            stack: "",
            isPackage: true,
            isPrivate: true
        }
    ]

    return (
        <div className="project">
            <div className="portfolio_showcase">
                <h3 className="title">FEATURED</h3>
                {
                    featuredProjects.map((project, index) => (
                        <ProjectCard {...project} key={index} id={index} />
                    ))
                }
            </div>
            <div className="portfolio_showcase">
                <h3 className="title">OPEN SOURCE CONTRIBUTIONS</h3>
                {
                    openSource.map((project, index) => (
                        <ProjectCard {...project} key={index} id={index} />
                    ))
                }
            </div>
            <div>
                <Button
                    previous={{ url: '/', text: 'Home' }}
                    next={{ url: '/article', text: 'Article' }}
                />
            </div>
        </div>
    )
}

export default Project